/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MailIcon32Regular = forwardRef('MailIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M8.659 10.247a1 1 0 0 0-1.318 1.506l5.037 4.407a5.5 5.5 0 0 0 7.244 0l5.037-4.407a1 1 0 0 0-1.317-1.506l-5.037 4.408a3.5 3.5 0 0 1-4.61 0l-5.037-4.408Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.5 5A5.5 5.5 0 0 0 2 10.5v11A5.5 5.5 0 0 0 7.5 27h17a5.5 5.5 0 0 0 5.5-5.5v-11A5.5 5.5 0 0 0 24.5 5h-17ZM4 10.5A3.5 3.5 0 0 1 7.5 7h17a3.5 3.5 0 0 1 3.5 3.5v11a3.5 3.5 0 0 1-3.5 3.5h-17A3.5 3.5 0 0 1 4 21.5v-11Z" })));
});
